export default "__VITE_ASSET__Cbt8_DdX__"